import { Navigate, useLocation } from "react-router-dom";
import { ErrorScreen } from "./ErrorScreen";
import { isUnavailableStateFromCurrentPageLoad } from "../utils/getDocumentationAreaRemovalReason";

// Reached through useNavigateToErrorScreen when a request fails with an error no screen handles
export const GenericErrorScreen = () => {
  const { state, search } = useLocation();

  // A refresh (or a direct visit) retries from the home route
  if (!isUnavailableStateFromCurrentPageLoad(state)) {
    return <Navigate replace to={{ pathname: "/", search }} />;
  }

  return <ErrorScreen />;
};
